import { styled } from "@mui/material/styles"

export const Content = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
  margin: theme.spacing(2, 0),
}))

export const Header = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  flexWrap: "wrap",
  gap: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}))

export const Title = styled("h1")(({ theme }) => ({
  margin: 0,
  fontSize: "1.5rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
}))

export const FilterContainer = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}))

export const TableContainer = styled("div")(({ theme }) => ({
  overflowX: "auto",
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(0, -2),
    width: `calc(100% + ${theme.spacing(4)})`,
  },
}))

export const BatchRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(1),
    alignItems: "flex-start",
  },
}))

export const BatchInfo = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}))

export const BatchActions = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  justifyContent: "flex-end",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    justifyContent: "flex-end",
  },
}))
